// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"uP-z","inlineTitle":"vP-z","sponsoredAdsWrapper":"wP-z","marketplaceRecosWrapper":"xP-z"};